export default {
  meta: {
    title: '添加规划商圈',
    parentPath: ['/recommend/branchnetworkplan'],
    url: '/recommend/addproject', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/recommend/branchnetworkplan'],
      name: ['规划管理'],
    },
  },
};
